var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortLower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5457 0.529151C9.86997 0.843542 9.86764 1.36456 9.54056 1.67603L4.99992 6L0.459459 1.67602C0.132393 1.36455 0.130061 0.84355 0.454328 0.529164C0.75966 0.233135 1.24385 0.229714 1.55334 0.521398L4.99992 3.76974L8.4467 0.521371C8.75619 0.229701 9.24038 0.233127 9.5457 0.529151Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortLower);
export default __webpack_public_path__ + "static/media/sortLower.dfdc5f03f10fe3379441554f02f59e05.svg";
export { ForwardRef as ReactComponent };